import { createContext } from "react";

export const DocumentosContext = createContext()
export const DocumentosFormContext = createContext()
export const DocumentosReportContext = createContext()